import * as Styles from './styles';

interface IProps {
    value1: string;
    value2: string;
    value3: string;
    value4: string;
}

function TransactionItemCard({ value1, value2, value3, value4 }: IProps) {
    return (
        <Styles.Wrapper>
            <Styles.DivFlex>
                <Styles.RowFlex>
                    <Styles.Value1>{value1}</Styles.Value1>
                    <Styles.Value2>{value2}</Styles.Value2>
                </Styles.RowFlex>
                <Styles.RowFlex>
                    <Styles.Value3>{value3}</Styles.Value3>
                    <Styles.Value4>
                        <Styles.Value4BackgroundText>
                            {value4}
                        </Styles.Value4BackgroundText>
                    </Styles.Value4>
                </Styles.RowFlex>
            </Styles.DivFlex>
        </Styles.Wrapper>
    );
}

export default TransactionItemCard;
